/**
 * Semantic class fragments for DentXE UI primitives.
 * Import only inside `components/ui/*` — feature code should use wrapped components.
 *
 * Account brand: `--color-primary`, `--color-brand-*` (org theme)
 * User scheme: `--bg-surface`, `--text-primary`, … (light/dark)
 */
export const themed = {
  focusRing:
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-surface)]',
  surface: {
    solid: 'bg-[var(--bg-surface)] text-[var(--text-primary)]',
    muted: 'bg-[var(--bg-surface-muted)] text-[var(--text-secondary)]',
    border: 'border-[var(--border-subtle)]',
    card: 'hairline rounded-xl2 border bg-[var(--bg-surface)] text-[var(--text-primary)] shadow-card',
  },
  text: {
    primary: 'text-[var(--text-primary)]',
    secondary: 'text-[var(--text-secondary)]',
    onBrand: 'text-white',
  },
  interactive: {
    primaryBtn:
      'bg-brand-500 text-white shadow-soft hover:bg-brand-600 focus-visible:ring-brand-500',
    secondaryBtn:
      'border bg-[var(--bg-surface)] text-[var(--text-primary)] hover:bg-[var(--bg-surface-muted)]',
    ghostBtn: 'text-[var(--text-primary)] hover:bg-[var(--bg-surface-muted)]',
    destructiveBtn: 'bg-coral-500 text-white hover:bg-coral-600',
  },
  field: {
    base: 'flex h-10 w-full rounded-lg border bg-[var(--bg-surface)] px-3 py-2 text-sm text-[var(--text-primary)] shadow-soft placeholder:text-[var(--text-secondary)] disabled:cursor-not-allowed disabled:opacity-50',
    border: 'border-[var(--border-subtle)]',
  },
  overlay: 'fixed inset-0 z-50 bg-black/40',
  dialog:
    'fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 rounded-xl2 border p-6 shadow-pop duration-200 bg-[var(--bg-surface)] border-[var(--border-subtle)] text-[var(--text-primary)]',
} as const;
